module.exports = __webpack_public_path__ + "static/media/nasa_impacts.e17bfc41.jpeg";